/* eslint-disable */
// prettier-ignore

import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/verify-login',
      name: 'verify-login',
      component: () => import('@/views/pages/VerifyLogin.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/verify-login/:id',
      name: 'verify-login',
      component: () => import('@/views/pages/VerifyLogin.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/pages/ResetPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/pages/ForgotPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    
    {
      path: '/confidence',
      name: 'confidence',
      component: () => import('@/views/pages/Confidence.vue'),
      meta: {
        layout: 'full',
      },
    },
    
    {
      path: '/ref/:ref',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    
        {
      path: '/',
      name: 'main',
      component: () => import('@/views/apps/main/Main.vue'),
          },
        {
      path: '/payresult/:id',
      name: 'payresult',
      component: () => import('@/views/apps/payresult/Payresult.vue'),
          },
        {
      path: '/payment/sbprocessing/:id',
      name: 'sbprocessing',
      component: () => import('@/views/apps/sbprocessing/Sbprocessing.vue'),
          },
        {
      path: '/payment/tfprocessing/:id',
      name: 'tfprocessing',
      component: () => import('@/views/apps/tfprocessing/Tfprocessing.vue'),
          },
        {
      path: '/payment/sbpayok/:id',
      name: 'sbpayok',
      component: () => import('@/views/apps/sbpayok/Sbpayok.vue'),
          },
        {
      path: '/payment/sbpayerror/:id',
      name: 'sbpayerror',
      component: () => import('@/views/apps/sbpayerror/Sbpayerror.vue'),
          },
        {
      path: '/page/:stype/:id',
      name: 'page',
      component: () => import('@/views/apps/page/Page.vue'),
          },
        {
      path: '/tinkoff-installment/:id',
      name: 'tinkoff-installment',
      component: () => import('@/views/apps/tinkoff-installment/TinkoffInstallment.vue'),
          },
        {
      path: '/personal-invitations/list',
      name: 'personal-invitations',
      component: () => import('@/views/apps/personal-invitations/PersonalInvitations.vue'),
            meta: {"pageTitle":"\u041b\u0438\u0447\u043d\u044b\u0435 \u043f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u044f"},
          },
        {
      path: '/personal-invitations/invite',
      name: 'invite',
      component: () => import('@/views/apps/invite/Invite.vue'),
            meta: {"pageTitle":"\u041f\u0440\u0438\u0433\u043b\u0430\u0441\u0438\u0442\u044c \u043d\u043e\u0432\u0438\u0447\u043a\u0430"},
          },
        {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/apps/orders/Orders.vue'),
            meta: {"pageTitle":"\u041c\u043e\u0438 \u043f\u043e\u043a\u0443\u043f\u043a\u0438"},
          },
        {
      path: '/tree-structure',
      name: 'tree-structure',
      component: () => import('@/views/apps/tree-structure/TreeStructure.vue'),
            meta: {"pageTitle":"\u0421\u0442\u0440\u0443\u043a\u0442\u0443\u0440\u0430 - \u0414\u0435\u0440\u0435\u0432\u043e"},
          },
        {
      path: '/tree-structure/:id',
      name: 'tree-structure-id',
      component: () => import('@/views/apps/tree-structure/TreeStructure.vue'),
            meta: {"pageTitle":"\u0421\u0442\u0440\u0443\u043a\u0442\u0443\u0440\u0430 - \u0414\u0435\u0440\u0435\u0432\u043e"},
          },
        {
      path: '/contracts',
      name: 'contracts',
      component: () => import('@/views/apps/contracts/Contracts.vue'),
            meta: {"pageTitle":"\u041a\u043e\u043d\u0442\u0440\u0430\u043a\u0442\u044b \u0437\u0430 \u043d\u0435\u0434\u0435\u043b\u044e"},
          },
        {
      path: '/info/how-to-by',
      name: 'how-to-by',
      component: () => import('@/views/apps/how-to-by/HowToBy.vue'),
            meta: {"pageTitle":"\u041f\u0440\u0430\u0432\u0438\u043b\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0438 "},
          },
        {
      path: '/how-use-refer',
      name: 'how-use-refer',
      component: () => import('@/views/apps/how-use-refer/HowUseRefer.vue'),
            meta: {"pageTitle":"\u041a\u0430\u043a \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c\u0441\u044f \u0440\u0435\u0444\u0435\u0440\u0430\u043b\u044c\u043d\u043e\u0439 \u0441\u0441\u044b\u043b\u043a\u043e\u0439"},
          },
        {
      path: '/certificates/business-packs',
      name: 'business-packs',
      component: () => import('@/views/apps/business-packs/BusinessPacks.vue'),
            meta: {"pageTitle":"\u0410\u043a\u0430\u0434\u0435\u043c\u0438\u044f"},
          },
        {
      path: '/certificates/repeat-purchases',
      name: 'repeat-purchases',
      component: () => import('@/views/apps/repeat-purchases/RepeatPurchases.vue'),
            meta: {"pageTitle":"\u041c\u0435\u0434\u0438\u0430 \u0431\u0430\u043d\u043a"},
          },
        {
      path: '/finance',
      name: 'finance',
      component: () => import('@/views/apps/finance/Finance.vue'),
            meta: {"pageTitle":"\u0424\u0438\u043d\u0430\u043d\u0441\u044b"},
          },
        {
      path: '/referral-links/navigation-report',
      name: 'navigation-report',
      component: () => import('@/views/apps/navigation-report/NavigationReport.vue'),
            meta: {"pageTitle":"\u041e\u0442\u0447\u0435\u0442 \u043f\u043e \u043f\u0435\u0440\u0435\u0445\u043e\u0434\u0430\u043c"},
          },
        {
      path: '/info/docs',
      name: 'docs',
      component: () => import('@/views/apps/docs/Docs.vue'),
            meta: {"pageTitle":"\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u044b"},
          },
        {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/apps/profile/Profile.vue'),
            meta: {"pageTitle":"\u041f\u0440\u043e\u0444\u0438\u043b\u044c"},
          },
        {
      path: '/(\\d+)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/(\[a-zA-Z]{1,}[0-9]{1,}\)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/(\[a-zA-Z]{1,}[0-9]{1,}[a-zA-Z]{1,}\)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/(\[a-zA-Z]{1,}[0-9]{1,}[a-zA-Z]{1,}[0-9]{1,}\)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/(\[0-9]{1,}[a-zA-Z]{1,}\)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/(\[0-9]{1,}[a-zA-Z]{1,}[0-9]{1,}\)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/(\[a-zA-Z]{1,}[0-9]{1,}[a-zA-Z]{1,}\)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/(\[0-9]{1,}[a-zA-Z]{1,}[0-9]{1,}[a-zA-Z]{1,}\)',
      name: 'refsignup',
      component: () => import('@/views/pages/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

if (localStorage.getItem('userData')) {
  
  
}

router.beforeEach(async (to, from, next) => {
  if (!store.getters['app/isLoggedIn'] && localStorage.getItem('accessToken') && localStorage.getItem('userData')) {
    store.commit('app/SET_USER', JSON.parse(localStorage.getItem('userData')))
    store.commit('app/SET_LOGGED_IN', true)
  }

  if (!localStorage.getItem('accessToken') && to.matched[0] && to.matched[0].path !== '/login') {
    if (to.matched[0].path === '/signup') {
      next()
    } else if (to.matched[0].path === '/verify-login/:id') {
      next()
    } else if (to.matched[0].path === '/ref/:ref') {
      next()
    }
    else if (to.matched[0].path === '/verify-login') {
      next()
    }
    else if (to.matched[0].path === '/(\\d+)') {
      next()
    }
    else if (to.matched[0].path === '/(\[a-zA-Z]{1,}[0-9]{1,}\)') {
      next()
    }
    else if (to.matched[0].path === '/(\[0-9]{1,}[a-zA-Z]{1,}\)') {
      next()
    }
    else if (to.matched[0].path === '/(\[0-9]{1,}[a-zA-Z]{1,}[0-9]{1,}\)') {
      next()
    }
    else if (to.matched[0].path === '/(\[a-zA-Z]{1,}[0-9]{1,}[a-zA-Z]{1,}\)') {
      next()
    }
    else if (to.matched[0].path === '/(\[a-zA-Z]{1,}[0-9]{1,}[a-zA-Z]{1,}[0-9]{1,}\)') {
      next()
    }
    else if (to.matched[0].path === '/(\[0-9]{1,}[a-zA-Z]{1,}[0-9]{1,}[a-zA-Z]{1,}\)') {
      next()
    }
    else if (to.matched[0].path === '/reset-password') {
      next()
    } else if (to.matched[0].path === '/confidence') {
      next()
    }
    else if (to.matched[0].path === '/confidenceBinar') {
      next()
    }
    else if (to.matched[0].path === '/forgot-password') {
      next()
    } else if (to.matched[0].path === '/report-form/:id') {
      next()
    } else if (to.matched[0].path === '/report-form/:id/:channel') {
      next()
    } else {
      next({
        path: '/login',
      })
    }
  }

  if (localStorage.getItem('accessToken') && to.matched[0] && to.matched[0].path === '/login') {
    next({
      path: '/',
    })
  }

  next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
